import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { useFirestore } from 'react-redux-firebase'
import { useQuery } from '@/hooks/useQuery'
// import { players } from '@/data/users'
// import { bets } from '@/data/bets'
import Loader from '@/components/Loader'
import Table from '@/components/Table'
import { convertAmount } from '@/utils/currencyResolver';
import { ShieldCheckIcon } from '@heroicons/react/solid'

export default function PlayerStats() {
  const firestore = useFirestore()
  const query = useQuery()
  const [userData, setUserData] = useState(null)
  const [userStats, setUserStats] = useState(null)

  useEffect(() => {
    const getData = async () => {
      const name = query.get("name")
      if (name) {
        try {
          const userRef = await firestore.collection("users").where("username", "==", name).get()
          const user = userRef.docs[0]
          const statsRef = await firestore.collection("stats").doc(user.id).get()
          if (user) {
            setUserData({
              username: user.data().username,
              joinDate: user.data().createdAt,
              hidden: user.data().privacy?.stats
            })
          }
          if (statsRef) {
            setUserStats(statsRef.data())
          }
        } catch (err) {
          console.log(err)
        }
      }
    }
    getData()
  }, [])

  if (!userData || !userStats) {
    return <Loader size="small" />
  }

  if (userData?.hidden) {
    return (
      <div className="py-4">
        <ShieldCheckIcon className="w-16 mx-auto mb-4" />
        <p className="text-center">This user has chosen to hide their statistics.</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center pt-4 pb-8">
        <p className="font-medium text-base text-white mb-1">{userData.username}</p>
        <p className="text-xs">Joined: {new Date(userData.joinDate.seconds * 1000).toLocaleString()}</p>
      </div>
      <div>
        <div className="bg-gray-900 p-3 rounded flex justify-between items-center">
          <p className="font-medium">Daily</p>
          <div className="flex items-center">
            <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" />
            {convertAmount(userStats.wagerDaily)}
          </div>
        </div>
        <div className="p-3 rounded flex justify-between items-center">
          <p className="font-medium">Weekly</p>
          <div className="flex items-center justify-center">
            <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" />
            {convertAmount(userStats.wagerWeekly)}
          </div>
        </div>
        <div className="bg-gray-900 p-3 rounded flex justify-between items-center">
          <p className="font-medium">Monthly</p>
          <div className="flex items-center justify-center">
            <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" />
            {convertAmount(userStats.wagerMonthly)}
          </div>
        </div>
        <div className="p-3 rounded flex justify-between items-center">
          <p className="font-medium">All Time</p>
          <div className="flex items-center justify-end space-x-1">
            <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" />
            {convertAmount(userStats.wagerAll)}
          </div>
        </div>
      </div>
    </div>
  )
}
